module.exports = __webpack_public_path__ + "img/login.67fa1e85.png";